import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DashboardMetadataComponent } from './components/dashboard-metadata/dashboard-metadata.component';
import { DialogComponent } from './components/dialog/dialog.component';
import { TruncatePipe } from './pipes/truncate.pipe';
import { YesNoPipe } from './pipes/yes-no.pipe';
import { RangePipe } from './pipes/range.pipe';
import { ToastComponent } from './components/toast/toast.component';
import {
  NgbModal,
  NgbPopoverModule,
  NgbToastModule
} from '@ng-bootstrap/ng-bootstrap';
import { ScheduleConfigPipe } from './pipes/schedule-config.pipe';
// import { TreeDropdownComponent } from './components/tree-dropdown/tree-dropdown.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
// import { TreeNodeComponent } from './components/tree-node/tree-node.component';

@NgModule({
  declarations: [
    DashboardMetadataComponent,
    DialogComponent,
    TruncatePipe,
    YesNoPipe,
    RangePipe,
    ScheduleConfigPipe,
    ToastComponent, 
    // TreeDropdownComponent,
    // TreeNodeComponent
  ],
  imports: [CommonModule, NgbPopoverModule, NgbToastModule, FormsModule, ReactiveFormsModule],
  providers: [NgbModal],
  exports: [
    DashboardMetadataComponent,
    DialogComponent,
    TruncatePipe,
    YesNoPipe,
    RangePipe,
    ScheduleConfigPipe,
    // ToastComponent,
    // TreeDropdownComponent
  ]
})
export class SharedModule {
  constructor() {}
}
